import { mapGetters } from 'vuex';
export default {
  data() {
    return {
    };
  },
  created() {
    console.warn('This layout is deprecated. Please upgrade to _core/fullscreen');
  },
  computed: {
    ...mapGetters({
      showContent: '_core/auth/isAuthenticated' && '_core/auth/hasCurrentRole'
    })
  },
  methods: {
    headTitle() {
      return this.$t('common.loading');
    }
  }
};
